
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.857 7.694a1 1 0 00-1.689-.04l-1.703 2.554H0v2h6.535l1.42-2.13.688 1.145 1.5 2.5a1 1 0 001.752-.068l1.276-2.552.83 1.105H22v-2h-7l-1.2-1.6a1 1 0 00-1.694.153l-1.185 2.37-2.064-3.437zm-7.001-4.58C2.688 1.546 4.184.209 6.14.209c1.805 0 3.248.925 4.184 1.75.256.226.482.45.675.66a9.45 9.45 0 01.675-.66c.936-.825 2.38-1.75 4.185-1.75 1.92 0 3.397 1.288 4.236 2.816.828 1.507 1.156 3.438.693 5.184h-2.116a2.783 2.783 0 00.164-.444c.343-1.206.129-2.643-.494-3.777-.627-1.141-1.542-1.779-2.483-1.779-1.11 0-2.097.576-2.862 1.25a7.652 7.652 0 00-1.096 1.204l-.052.075-.01.016a1 1 0 01-1.678 0l-.064-.09a7.646 7.646 0 00-1.096-1.204c-.764-.675-1.751-1.25-2.861-1.25-.96 0-1.893.663-2.518 1.843-.621 1.17-.81 2.641-.419 3.848.03.092.071.195.124.308H1.21c-.454-1.714-.145-3.604.645-5.093zM13.73 14.209h2.783a84.492 84.492 0 01-2.796 2.822 99.45 99.45 0 01-2.006 1.884l-.03.027-.01.01h-.001a1 1 0 01-1.339 0l-.01-.01-.03-.027a46.73 46.73 0 01-.542-.496c-.363-.337-.873-.816-1.466-1.388a84.585 84.585 0 01-2.795-2.822H8.27A92.424 92.424 0 0011 16.85a98.971 98.971 0 002.73-2.642z","fill":"#161616","fill-opacity":".88"}})])
          )
        }
      }
    